import {
  Col,
  Row,
  //  Select, 
  Space
} from "antd";
import { FC } from "react";
import { useSelector } from "react-redux";
import { AddSvg } from "utils/svgs";
import { checkPermission } from "utils/utils";
import styles from "./index.module.scss";
import { SearchAndFilterProps } from "./types";

// For search filter and paginate
const SearchAndFilter: FC<SearchAndFilterProps> = (props) => {
  // Init
  const {  title, openDrawerHandler } = props;

  const userPermissions = useSelector(
    (state: any) => state?.userProfile?.data?.permissions
  );

  const isAddPermission = checkPermission(userPermissions, {
    permissionName: 'Roles',
    permission: ['add'],
  });

  // JSX
  return (
    <div className={styles["search-filter"]}>
      <div className={styles["search-filter__wrapper"]}>
        <Row justify={"space-between"}>
          <Col>
            <div className={styles["search-filter__wrapper--title"]}>{title}</div>
          </Col>
          <Col>
            <Space>
              {/* <Input
                className={styles["search-filter__search"]}
                placeholder="Search by Role Name or Description"
                suffix={<SearchOutlined />}
                onChange={performSearchHandler}
                value={searchValue}
                size="large"
              /> */}
              {/* <Select
                defaultValue="All"
                onChange={performFilterHandler}
                style={{ width: 200 }}
                options={[
                  { label: "All", value: "all" },
                  { label: "Active", value: "active" },
                  { label: "Inactive", value: "inactive" },
                ]}
                size="large"
              /> */}

              <div className={styles['user-table__action']}>
                {(isAddPermission || userPermissions.isAdmin) && (
                  <button
                    className={`btn-blue ${styles['role-table__action--button']}`}
                    onClick={openDrawerHandler}
                  >
                    <AddSvg />
                    <p>Add Role</p>
                  </button>
                )}
              </div>
            </Space>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SearchAndFilter;
